import { AfterViewInit, Component } from '@angular/core';
import { HeroComponent } from "../hero/hero.component";
import { ProblemComponent } from "../problem/problem.component";
import { SolutionComponent } from "../solution/solution.component";
import { TestimonialsComponent } from "../testimonials/testimonials.component";
import { PricingComponent } from "../pricing/pricing.component";
import { FaqComponent } from "../faq/faq.component";

@Component({
    selector: 'app-landing',
    templateUrl: './landing-page.component.html',
    imports: [HeroComponent, ProblemComponent, SolutionComponent, TestimonialsComponent, PricingComponent, FaqComponent]
})
export class LandingPageComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    this.initSmoothScroll();
    this.initScrollFadeIn();
  }

  private initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = (anchor as HTMLAnchorElement).getAttribute('href');
        if (!targetId) return;

        const target = document.querySelector(targetId);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  private initScrollFadeIn() {
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          obs.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0,
      rootMargin: '0px 0px -120px 0px',
    }
  );

  document.querySelectorAll('.scroll-fade-in').forEach(el => {
    observer.observe(el);
  });
}

}
